// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import jwt_decode from 'jwt-decode';
import { FeatureFlags, IDecodedAuthToken } from '../../types/auth';
import { IManageUser, UserRole, UserSource } from '../../types/user';
import { OrgType } from '../../types/group';

export default {
  //   This is for testing purposes so we can mock the jwt_decode library
  _jwt_decode: jwt_decode,

  getUserFromToken() {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return decoded && decoded.usr || '';
    }

    return '';
  },

  getUidFromToken() {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return decoded && decoded.uid || -1;
    }

    return -1;
  },

  getGroupFromToken() {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return decoded && decoded.gid || -1;
    }

    return -1;
  },

  getSourceFromToken() {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return decoded && decoded.src || UserSource.Cigent;
    }

    return UserSource.Cigent;
  },

  getFeatureFlagFromToken(featureFlag: FeatureFlags): boolean {
    const token = localStorage.getItem('token');

    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return (decoded && decoded.con && decoded.con[featureFlag] === 1) || false;
    }

    return false;
  },

  isPasswordExpired(): boolean {
    const token = localStorage.getItem('token');
    if (token) {
      const decoded: IDecodedAuthToken = this._jwt_decode(token);
      return decoded?.con?.fpw === 1;
    }
    return false;
  },

  isUserTourEnabled(user: IManageUser): boolean {
      return user &&
            !this.isPasswordExpired() &&
            !this.getFeatureFlagFromToken('ftf') &&
            user.org_type.value === OrgType.CUSTOMER &&
            user.role === UserRole.ADMIN;
  },

  getTokenIdFromToken() {
      const token = localStorage.getItem('token');

      if (token) {
          const decoded: IDecodedAuthToken = this._jwt_decode(token);
          return decoded && decoded.token_id || 'anonymous';
      }
      return 'anonymous';
  }
};
